import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=2854007a&scoped=true"
var script = {}
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=2854007a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2854007a",
  null
  
)

export default component.exports